<template>
  <div class="problem-box" @click="$router.push({ path: '/question' })">
    <img src="@/assets/img/images/home/question.png" alt="question" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.problem-box {
  cursor: pointer;
  position: fixed;
  bottom: 75px;
  right: 0px;
  width: 52px;
  height: 52px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
